import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { OnSiteMovementEditor } from 'models/on-site-movement/on-site-movement.models';
import { ValidationResult } from 'models/projects/validation.models';
import { AppConfig } from '../../../app/app.config';

@IonicPage()
@Component({
  selector: 'page-on-site-movement-edit-complete',
  templateUrl: 'on-site-movement-edit-complete.html',
})
export class OnSiteMovementEditCompletePage {

  config = AppConfig.settings;
  editor: OnSiteMovementEditor;
  validationResult: ValidationResult;
  callback: Function;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
  ) {
  }

  ngOnInit() {
    this.ionViewEnter();
  }

  public async ionViewEnter() {
    this.editor = this.navParams.get('editor');
    this.validationResult = this.navParams.get('validationResult');
    this.callback = this.navParams.get('callback');
  }

  public async cancel() {
    this.callback(this.editor, true).then(() => {
      this.navCtrl.pop();
    });
  }

  public async confirm() {
    this.callback(this.editor, false).then(() => {
      this.navCtrl.pop();
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/on-site-movement/on-site-movement-edit-complete/on-site-movement-edit-complete.ts